export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/logo-main.4e049c3f.svg","height":65,"width":78};